import React, { useState, useEffect ,useRef} from "react";
import { IdleTimerProvider } from "react-idle-timer";
import { refreshAccessToken } from "./TokenUtils";
import ToastNotification from "./ToastNotification"; 
import config from "./config";

const IDLE_TIMEOUT = config.IDLE_TIMEOUT;
const AUTO_LOGOUT_TIME = config.AUTO_LOGOUT_TIME;

const SessionManager = () => {
  const [isIdle, setIsIdle] = useState(false);
   const toastRef = useRef(null);
  useEffect(() => {
    let logoutTimer;
    if (isIdle) {
      // If idle toast is shown, start auto-logout countdown
      logoutTimer = setTimeout(() => {
        handleLogout();
      }, AUTO_LOGOUT_TIME);
    }

    return () => clearTimeout(logoutTimer); // Cleanup on state change
  }, [isIdle]);

  const handleOnIdle = () => {
    setIsIdle(true);
    
    toastRef.current.showToast(
      `You’ve been inactive. Do you want to stay logged in?`,
      "warning",
      true, // Show buttons
      handleStayLoggedIn,
      handleLogout
    );
  };

  const handleStayLoggedIn = async () => {
    setIsIdle(false); // Make sure to set idle to false first
    toastRef.current.showToast("Session renewed! You're still logged in.", "success");

    await refreshAccessToken(); // Optional: Refresh token when user chooses to stay
};


  const handleLogout = () => {
    console.log("User clicked 'Log Out'...");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    // Show logout confirmation toast
    toastRef.current.showToast("You have been logged out due to inactivity.", "danger");
    window.location.href = "/"; // Redirect to login
  };

  return (
    <IdleTimerProvider
      timeout={IDLE_TIMEOUT} // Detects idle time
      onIdle={handleOnIdle}
      debounce={500}
    >
      {/* Custom ToastNotification component to handle alerts */}
       <ToastNotification ref={toastRef} />
    </IdleTimerProvider>
  );
};

export default SessionManager;
